import { TRACKING_MAPPING } from '@js/common/constants'

import { QuizContextType } from '@f/applications/QuizApp/context/QuizContext'
import {
  QuizStep,
  SelectedOptionNumber
} from '@f/applications/QuizApp/partials/types'

export const prefillRadioStep = (
  step: QuizStep,
  selectedOptionNumber: SelectedOptionNumber
): QuizStep => {
  return {
    ...step,
    values: step.values.map((value, index) => {
      const optionIndex = selectedOptionNumber - 1
      return index === 0
        ? { ...value, value: step.options?.[optionIndex]?.value }
        : value
    })
  }
}

export const trackPrefilledFirstStep = (
  step: QuizStep,
  flow_information: QuizContextType['tracking']['flow']['flow_information']
) => {
  window._wt({
    category: 'question',
    action: 'display',
    values: [
      {
        type: 'name',
        value: step._wtName
      }
    ],
    flow_information: {
      ...flow_information,
      flow_step: 1
    }
  })

  window._wt({
    category: 'form',
    action: 'submit',
    location: `question-${step._wtName}`,
    values: step.values.map(({ value, name }) => ({
      type: TRACKING_MAPPING[name]?.label || name,
      value: value
    })),
    indicates: ['funnel-step-change'],
    flow_information: {
      ...flow_information,
      flow_step: 1
    }
  })
}
